import React from "react";
import { useSelector } from "react-redux";

function AdminLayout({ children }) {
  // REDUX DATA
  const { profile } = useSelector((state) => state.UserReducer);

  // CONST VALS
  const isAdmin = profile?.is_superuser;

  return (
    <>
      {isAdmin ? (
        children
      ) : (
        <div className="unauthorized-access">
          <p>You are not authorized to access this page</p>
        </div>
      )}
    </>
  );
}

export default AdminLayout;
